import React from 'react';
interface LogoProps {
  className?: string;
  alt?: string;
}
export function Logo({
  className = '',
  alt = 'Laugh Haus'
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/qhZq9KwqFxUgsT2DnC53fc/ChatGPT_Image_May_10,_2026,_09_25_09_PM.png" alt={alt} className={className} data-id="element-203" />;
}